import { useEffect, useRef } from 'react'
import { echo } from './echo'

type Options = {
  farmId: number | string | null | undefined
  eventName?: string
  channelBuilder?: (farmId: string) => string
  onEvent?: (payload: any) => void
}

export function useRealtimeFarmNotifications({
     farmId,
     eventName = '.farm.notification',
     channelBuilder = (id) => `farms.${id}`,
     onEvent,
   }: Options) {

  const onEventRef = useRef(onEvent)
  onEventRef.current = onEvent

  useEffect(() => {
    if (!farmId) return

    const chanName = channelBuilder(String(farmId))
    const channel = (echo as any).private(chanName)

    const listener = (payload: any) => {
      onEventRef.current?.(payload)
    }

    channel.listen(eventName, listener)

    return () => {
      try {
        channel.stopListening(eventName, listener)
      } catch {}
    }
  }, [farmId, eventName, channelBuilder])
}
